module.exports = __webpack_public_path__ + "static/thpkleopardmuslin-d1ef12ec328cc73bf2cfc27b85960493.jpeg";